import axios from 'axios'
import Cookies from 'js-cookie'
import { Message } from 'byted-vui'

const jsonToQuery = (obj, prefix) => (typeof prefix === 'undefined' ? '?' : prefix) +
  Object.keys(obj)
    .filter(item => typeof obj[item] !== 'undefined' && obj[item] !== null)
    .map(item => [item, encodeURIComponent(obj[item])].join('='))
    .join('&')

const AXIOS_DEFAULTS = {
  retry: 1, // 超时请求1次数
  waitTime: 1000, // 超时请求间隙
  errorCodes: [404], // 重试的状态码
  timeout: 1000 * 60 * 1 // get,head 设置超时，超时时间为1分钟,POST不限制
}
const instance = axios.create({
  ...AXIOS_DEFAULTS,
  baseURL: process.client ? process.env.BASE_URL : 'http://localhost:3100/'
})
instance.CancelToken = axios.CancelToken

const defaultOptions = {
  // request interceptor handler
  reqHandleFunc: (context = {}) => {
    const { method: httpMethod = '', headers, data, params } = context
    if (httpMethod.toLowerCase() === 'post') {
      headers['X-CSRFToken'] = Cookies.get('csrftoken')
      headers['AC-CSRFToken'] = Cookies.get('ac_csrftoken')
    }
    if (
      httpMethod.toLowerCase() === 'post' ||
      httpMethod.toLowerCase() === 'put'
    ) {
      context.timeout = 0 // post不限制超时时间
    }

    return context
  },
  resHandleFunc: (response) => {
    const { data, status, statusText, headers, config } = response
    if (
      (status !== 200)
    ) {
      Message.error({ message: `${status}: ${statusText}` })
      return Promise.reject(response)
    }
    const _fe_extra_fields_data = {
      log_id: headers["x-tt-logid"] || "",
      req_url: config?.url || ""
    };
    if (Object.prototype.toString.call(data) === "[object Object]") {
      data._fe_extra_fields_data = _fe_extra_fields_data
    }

    return data
  },
  resErrorFunc: (error) => {
    if(!error) error = {}
    try {
      const obj = {
        errorCode: error.response?.status?.toString(),
        requestUrl: error.config?.url,
        logid: error.response?.headers?.['x-tt-logid']?.toString(),
        msg: error.message
      }
      process.client && window.SlardarWeb?.('sendEvent', {
        name: "catch_axios_error_detail", // 这里是 事件指标, starling上出来的比较快
        metrics: {
          getstarted_catch_axios_error_detail: 1,
        },
        categories: obj  // 这里是 维度 (自定义的维度), starling上出来的很慢!! 可能要半小时...
      });
    } catch (e) {
      console.error(e)
    }
    Message.error({ message: error.message })
    return Promise.reject(error)
  }
}

// 设置默认的请求配置
instance.defaults.headers.post['Content-Type'] = 'application/json'

// 初始化请求拦截器
instance.interceptors.request.use(
  context => defaultOptions.reqHandleFunc(context)
)

instance.interceptors.response.use(
  response => defaultOptions.resHandleFunc(response),
  error => defaultOptions.resErrorFunc(error)
)

export default instance
